import { useEffect, useState } from "react";
import "./power.css";
import { generateAddend } from "../../utils/generateNumber";



export default function PowerConfig({ config, onStart }) {
  const [addValue, setAddValue] = useState(0);
  const [startValue, setStartValue] = useState(0);
const [targetCount, setTargetCount] = useState(0);

useEffect(() => {
  if (config?.digit) {
    const value = generateAddend(config.digit);
    setAddValue(value);

    if (config.exerciseType === "Subtraction") {
      const count = Math.floor(Math.random() * (60 - 15 + 1)) + 15;

      setTargetCount(count);
      setStartValue(value * count); // divisible
    } else {
      setStartValue(0);
      setTargetCount(0);
    }
  }
}, [config]);

  return (
    <div className="power-screen">

      <div className="top-pill">Power Exercise</div>

      <div className="info-text">
      {config?.exerciseType === "Addition" ? (
  <>
    Starting from 0 <br />
    Add +{addValue} for {config?.time}
  </>
) : (
  <>
    Starting from {startValue} <br />
    Subtract {addValue} for {config?.time}
  </>
)}
      </div>

      <div className="power-card">

        <div className="card-title">
          {config?.exerciseType}
        </div>

        <div className="row">
          <span>
            {config?.exerciseType === "Addition"
              ? "Keep Adding"
              : "Keep Subtracting"}
          </span>
          <span>{addValue}</span>
        </div>

       <div className="row">
  <span>Starts from</span>
  <span className="underline">
    {config?.exerciseType === "Addition" ? 0 : startValue}
  </span>
</div>

        <div className="row">
          <span>Time</span>
          <span>{config?.time}</span>
        </div>

      </div>
<button
  className="start-btn"
 onClick={() => onStart({ addValue, startValue, targetCount })}
>
  Start
</button>

    </div>
  );
}